export default __webpack_public_path__ + "static/media/mena18.5a13db42.PNG";